
import React from "react";
import {getBrand, getStudentDetails } from "../lib/functions";
import AssignmentListItem from "./AssignmentListItem.js";
import Footer from "./Footer.js";
import Settings from "./Settings.js";
import Sidebar from "./Sidebar";
import MobileHeader from "./MobileHeader";

export default class Main extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      brand : null,
      studentDetails : null,
      assignmentCounts : null,
      menuItems : null,
      listSelected: "active",
      urgent: false,
      hasAssignments: false,
      showSidebar: true,
      viewSelection: "Assignments due",
      showSettings : false
    }
  }


  componentDidMount = () =>  {
    this.setState({
      brand : getBrand()
    });
    this.init("4");

    if (window.screen.width > 600) {
      this.setState({showSidebar: true})
    } else {
      this.setState({showSidebar: false})
    }

  }

  init = (filter) =>  {

      getStudentDetails(filter, data => {


        const menuItemsSorted = [...data[1]].sort((a, b) => a.sortorder - b.sortorder);

        this.setState({studentDetails : data[0], menuItems : menuItemsSorted});

        if (data[0].length == 0) {
          this.setState({hasAssignments : false})
        } else {
          this.setState({ hasAssignments: true })
        }
    });
  }


sidebarToggle = () => {
  this.setState(prevState => ({showSidebar : !prevState.showSidebar}))
};

showSettings = (e) => {
    this.setState({showSettings : true, viewSelection : "Settings"});
    const getClass = [...document.querySelectorAll('.sidebar-item')]
    getClass.map(x => {
      return x.classList.remove("active");
    })
    e.currentTarget.classList.add("active");
}


getSelection = (e) => {

  this.setState({showSettings : false});
  let thisSelection = e.currentTarget.dataset.selection;
  let thisFilter = e.currentTarget.dataset.filter;
  this.init(thisFilter)
  const getClass = [...document.querySelectorAll('.sidebar-item')]
  getClass.map(x => {
    return x.classList.remove("active");
  })
  e.currentTarget.classList.add("active");
  this.setState({viewSelection: thisSelection})


};

  render() {
    const { brand, studentDetails, hasAssignments, showSidebar, viewSelection, menuItems, showSettings} = this.state;

  return (
    <>
      <MobileHeader sidebartoggle={this.sidebarToggle} showSidebar={showSidebar} student={this.props.student} />
      <Sidebar showLink={this.showLinkAccount} showSettings={this.showSettings} sidebartoggle={this.sidebarToggle} getSelection={this.getSelection} showSidebar={showSidebar} student={this.props.student} menuitems={menuItems}/>
      <div className={`Main ${showSidebar === true ? "sidebar-open" : "sidebar-close"}`}>
        <div className="display-area">

          <h1 className="selection-main-header">{viewSelection}</h1>

          {showSettings == false ?
                    <>

                    {hasAssignments ?
                    <>
                      <div className="list-group">
                        <ul className="row assignment-ul">
                          {studentDetails.map(c =>
                            <AssignmentListItem
                              key={c.assignmentkey}
                              data={c}
                              brand={brand}
                            />
                            )}
                        </ul>
                      </div>
                    </>
                  :
                  <p className="noAssignments">There is currently nothing to show for <span className="lower-case bold-text">{viewSelection}</span>.<br/>Please speak to your teacher if you think this is incorrect.</p>
                }
        </>
        :
        <Settings student={this.props.student} gethelp={this.props.gethelp}/>
}

      <Footer />
      </div>
      </div>
    </>
  )
   }
}
